<formly-form [fields]="fields" [form]="form" [model]="model()">
</formly-form>
